export enum ApplicationType {
  ProfessionalWeb = 'ProfessionalWeb',
  ProfessionalMobile = 'ProfessionalMobile',
  PatientWeb = 'PatientWeb',
  PatientMobile = 'PatientMobile',
  AdminWeb = 'AdminWeb',
}
